import { useDispatch, useSelector } from 'react-redux';

import { parentVideoCategory, videoCategoryList } from 'api/endpoints/video_category';
import { ENUM_TYPE_VIDEO_CATEGORY } from 'constants/enum';
import { setVideoCategoriesAssessment, setVideoCategoriesMovement } from 'store/actions/video-catergory';
import { convertToQueryString } from 'utils/helper';

const useVideoCategory = () => {
  const dispatch = useDispatch();
  const { me } = useSelector((state) => state.auth);
  const { videoCategoriesAssessment, videoCategoriesMovement } = useSelector((state) => state.videoCategory);

  /**
   * Get video categories by type
   * @param {string} type - The type of video category
   * @returns {Promise<void>}
   */
  const getVideoCategory = async (type) => {
    const query = convertToQueryString({ type });
    const response = await videoCategoryList(query);
    return response.data || [];
  };

  /**
   * Get all video categories
   * @param {boolean} overwrite - Whether to overwrite the data in the store
   * @returns {Promise<void>}
   */
  const getAllVideoCategory = async (overwrite = true, type = null) => {
    if (!overwrite) {
      /* If not overwritten, check to see if there is data in the store
       * If there is data in the store, return
       * If there is no data in the store, call the API to get the data
       */
      if (videoCategoriesAssessment.length > 0 && videoCategoriesMovement.length > 0) {
        return;
      }
    }

    if (me) {
      if (type === ENUM_TYPE_VIDEO_CATEGORY.ASE || type === null) {
        const assessment = await getVideoCategory(ENUM_TYPE_VIDEO_CATEGORY.ASE);
        const assessmentData = assessment.map((item) => ({
          label: `${item.name_vi || item.name}`,
          value: item.id,
          type: item.type,
        }));
        dispatch(setVideoCategoriesAssessment(assessmentData));
      }
      if (type === ENUM_TYPE_VIDEO_CATEGORY.DAY || type === null) {
        const movement = await getVideoCategory(ENUM_TYPE_VIDEO_CATEGORY.DAY);
        const movementData = movement.map((item) => ({
          label: `${item.name_vi || item.name}`,
          value: item.id,
          type: item.type,
        }));
        dispatch(setVideoCategoriesMovement(movementData));
      }
    }
  };

  /**
   * Get all parent video categories
   * @returns {Promise<void>}
   */
  const getAllParentVideoCategory = async () => {
    const response = await parentVideoCategory();
    if (response?.data) {
      return response.data;
    }
    return [];
  };

  return { getVideoCategory, getAllVideoCategory, getAllParentVideoCategory };
};

export default useVideoCategory;
